import { render, staticRenderFns } from "./changeWhProject.vue?vue&type=template&id=5bd3b023&"
import script from "./changeWhProject.vue?vue&type=script&lang=js&"
export * from "./changeWhProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports